export { getStaticPaths } from '@cinch-nx/feature-collection-location'
export { getStaticProps } from '@cinch-nx/feature-collection-location'
export { CollectionLocation as default } from '@cinch-nx/feature-collection-location'
